export const ENDPOINTS = {
    LOGIN: 'api/v1/erp/auth/login',
    PROFILE: 'api/v1/erp/users/profile',
    USERS: 'api/v1/erp/users/list',
    CREATE_USER: 'api/v1/erp/users',
    EDIT_USER: 'api/v1/erp/users/edit-user',
    DELETE_USER: 'api/v1/erp/users/delete-user',
    GET_PRODUCTS: 'api/v1/erp/products',
    GET_PRODUCT_PRICES: 'api/v1/erp/products/prices',
    CREATE_PRODUCT: 'api/v1/erp/products',
    GET_PRODUCT_DROPDOWNS: 'api/v1/erp/products/dropdowns',
    GET_PRODUCT_BY_ID: (id: string | number) => `api/v1/erp/products/${id}`,
    GET_CATEGORIES: 'api/v1/erp/products/categories',
    GET_BRANDS: 'api/v1/erp/products/brands',
    CREATE_BRAND: 'api/v1/erp/products/brands',
    UPDATE_BRAND: (id: string | number) => `api/v1/erp/products/brands/${id}`,
    GET_UNITS: 'api/v1/erp/products/units',
    CREATE_UNIT: 'api/v1/erp/products/units',
    UPDATE_UNIT: (id: string | number) => `api/v1/erp/products/units/${id}`,
    GET_SIZES: 'api/v1/erp/products/sizes',
    CREATE_SIZE: 'api/v1/erp/products/sizes',
    UPDATE_SIZE: (id: string | number) => `api/v1/erp/products/sizes/${id}`,
    GET_PACKAGINGS: 'api/v1/erp/products/packagings',
    CREATE_PACKAGING: 'api/v1/erp/products/packagings',
    UPDATE_PACKAGING: (id: string | number) => `api/v1/erp/products/packagings/${id}`,
    GET_CRATES: 'api/v1/erp/products/crates',
    GET_CRATE_BY_ID: (id: string | number) => `api/v1/erp/products/crates/${id}`,
    CREATE_CRATE: 'api/v1/erp/products/crates',
    UPDATE_CRATE: (id: string | number) => `api/v1/erp/products/crates/${id}`,
    DELETE_CRATE: (id: string | number) => `api/v1/erp/products/crates/${id}`,
    ROLES: 'api/v1/erp/roles',
    ROLE_DETAIL: 'api/v1/erp/roles/detail',
    ROLE_PERMISSIONS: 'api/v1/erp/roles/permissions',
    PERMISSIONS: 'api/v1/erp/permissions',
    USER_MENU: 'api/v1/erp/users/menu',
    USER_ROLES: 'api/v1/erp/users/roles',
    MODULES_LIST: 'api/v1/erp/modules/list',

    // Locations Endpoints
    GET_ZONES: 'api/v1/erp/locations/zones',
    CREATE_ZONE: 'api/v1/erp/locations/zones',
    UPDATE_ZONE: (id: string | number) => `api/v1/erp/locations/zones/${id}`,
    DELETE_ZONE: (id: string | number) => `api/v1/erp/locations/zones/${id}`,

    GET_CITIES: 'api/v1/erp/locations/cities',
    CREATE_CITY: 'api/v1/erp/locations/cities',
    UPDATE_CITY: (id: string | number) => `api/v1/erp/locations/cities/${id}`,
    DELETE_CITY: (id: string | number) => `api/v1/erp/locations/cities/${id}`,

    // Territories Endpoints
    GET_TERRITORIES: 'api/v1/erp/locations/territories',
    GET_TERRITORY_BY_ID: (id: string | number) => `api/v1/erp/locations/territories/${id}`,
    CREATE_TERRITORY: 'api/v1/erp/locations/territories',
    UPDATE_TERRITORY: (id: string | number) => `api/v1/erp/locations/territories/${id}`,
    DELETE_TERRITORY: (id: string | number) => `api/v1/erp/locations/territories/${id}`,

    GET_DEPOS: 'api/v1/erp/locations/depos',
    CREATE_DEPO: 'api/v1/erp/locations/depos',
    UPDATE_DEPO: (id: string | number) => `api/v1/erp/locations/depos/${id}`,
    DELETE_DEPO: (id: string | number) => `api/v1/erp/locations/depos/${id}`,

    GET_ROUTES: 'api/v1/erp/locations/routes',
    CREATE_ROUTE: 'api/v1/erp/locations/routes',
    UPDATE_ROUTE: (id: string | number) => `api/v1/erp/locations/routes/${id}`,
    DELETE_ROUTE: (id: string | number) => `api/v1/erp/locations/routes/${id}`,

    // Orders Endpoints
    GET_ORDERS: 'api/v1/erp/orders',
    GET_ORDER_BY_ID: (id: string | number) => `api/v1/erp/orders/${id}`,
    UPDATE_ORDER_STATUS: (id: string | number) => `api/v1/erp/orders/${id}/status`,
    EXPORT_SAP_ORDERS: 'api/v1/erp/orders/export/sap-format',
    EXPORT_DELIVERY_ROUTE_SHEET: 'api/v1/erp/orders/export/delivery-route-sheet',

    // Distributor Endpoints
    GET_DISTRIBUTORS: 'api/v1/erp/distributor',
    GET_DISTRIBUTOR_BY_ID: (id: string | number) => `api/v1/erp/distributor/${id}`,
    CREATE_DISTRIBUTOR: 'api/v1/erp/distributor',
    UPDATE_DISTRIBUTOR: (id: string | number) => `api/v1/erp/distributor/${id}`,

    // Scheme Endpoints
    GET_SCHEMES: 'api/v1/erp/schemes',
    SCHEMES_LIST: 'api/v1/erp/schemes/list',
    GET_SCHEME_BY_ID: (id: string | number) => `api/v1/erp/schemes/${id}`,
    CREATE_SCHEME: 'api/v1/erp/schemes',
    UPDATE_SCHEME: (id: string | number) => `api/v1/erp/schemes/${id}`,
    DELETE_SCHEME: (id: string | number) => `api/v1/erp/schemes/${id}`,
    EXTEND_SCHEME: (id: string | number) => `api/v1/erp/schemes/${id}/extend`,

    // Incentive Endpoints
    GET_INCENTIVES: 'api/v1/erp/incentives',
    INCENTIVES_LIST: 'api/v1/erp/incentives/list',
    GET_INCENTIVE_BY_ID: (id: string | number) => `api/v1/erp/incentives/${id}`,
    CREATE_INCENTIVE: 'api/v1/erp/incentives',
    UPDATE_INCENTIVE: (id: string | number) => `api/v1/erp/incentives/${id}`,
    DELETE_INCENTIVE: (id: string | number) => `api/v1/erp/incentives/${id}`,
    EXTEND_INCENTIVE: (id: string | number) => `api/v1/erp/incentives/${id}/extend`,
    INCENTIVE_TEMPLATE: 'api/v1/erp/incentives/template',
    INCENTIVE_UPLOAD: 'api/v1/erp/incentives/upload',
    INCENTIVE_DOWNLOAD: 'api/v1/erp/incentives/download',

    // Sale Document Endpoints
    SALE_DOCUMENTS: 'api/v1/erp/sale-document',

    // Sale Organization Endpoints
    SALE_ORGANIZATIONS: 'api/v1/erp/sale-organization',

    // ITCA Endpoints
    ITCA: 'api/v1/erp/itca',

    // Distributor Channel Endpoints
    DISTRIBUTOR_CHANNELS: 'api/v1/erp/channels',
    UPDATE_DISTRIBUTOR_CHANNEL: (id: string | number) => `api/v1/erp/channels/${id}`,

    // Product Margins Endpoints
    GET_DISTRIBUTOR_MARGINS: 'api/v1/erp/products/distributor-margins',
    GET_RETAILER_MARGINS: 'api/v1/erp/products/retailer-margins',
    GET_TRADE_MARGINS: 'api/v1/erp/products/trade-margins',

    // Distributor Wallet Endpoints
    DISTRIBUTOR_WALLET: 'api/v1/erp/wallet',
    DISTRIBUTOR_WALLET_BY_ID: (id: string | number) => `api/v1/erp/wallet/distributors/${id}`,
    DISTRIBUTOR_WALLET_UPLOAD: 'api/v1/erp/wallet/upload-balances',
    DISTRIBUTOR_WALLET_TEMPLATE: 'api/v1/erp/wallet/template',
    // Inventory Endpoints
    INVENTORY_TEMPLATE: 'api/v1/erp/inventory/template',
    INVENTORY_UPLOAD: 'api/v1/erp/inventory/upload',
    DEPO_STOCK: (depoId: string | number) => `api/v1/erp/inventory/depo/${depoId}/stock`,
    INVENTORY_STOCK: 'api/v1/erp/inventory/stock',
    STOCK_REGISTER: 'api/v1/erp/inventory/stock',
    DEPO_INWARD: (depoId: string | number) => `api/v1/erp/inventory/depo/${depoId}/inward`,
    CHECK_STOCK_AVAILABILITY: 'api/v1/erp/inventory/check-availability',

    // SAP Sync Endpoints
    SAP_METRICS: 'api/v1/erp/sap/logs/metrics',
    SAP_LOGS: 'api/v1/erp/sap/logs',
    SAP_LOG_BY_ID: (id: string | number) => `api/v1/erp/sap/logs/${id}`,
    SAP_RETRY_LOG: (id: string | number) => `api/v1/erp/sap/logs/${id}/retry`,
    SAP_SYNC_DAILY_ORDERS: 'api/v1/erp/sap/orders/sync-daily',
    SAP_TRIGGER_INBOUND_SYNC: 'api/v1/erp/sap/sync',
    SAP_TRIGGER_JOB: 'api/v1/erp/sap/jobs/trigger',
    SAP_TEST_LIST_FILES: 'api/v1/erp/sap/test-list-files',
}